import React from 'react';

const SvgIconMotorcycleOff = props => (
  <svg width={155} height={88} viewBox="0 0 155 88" {...props}>
    <defs>
      <linearGradient
        id="icon-motorcycle-off_svg__a"
        x1="-24.303%"
        x2="74.407%"
        y1="-57.17%"
        y2="113.318%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__b"
        x1="-2.054%"
        x2="85.243%"
        y1="-23.815%"
        y2="94.179%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__c"
        x1="30.277%"
        x2="82.328%"
        y1="11.304%"
        y2="90.104%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__d"
        x1="40.941%"
        x2="58.97%"
        y1="21.32%"
        y2="79.674%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__e"
        x1="16.204%"
        x2="75.739%"
        y1="-6.164%"
        y2="79.561%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__f"
        x1="30.291%"
        x2="75.51%"
        y1="2.794%"
        y2="84.934%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__g"
        x1="34.447%"
        x2="66.217%"
        y1="44.072%"
        y2="63.621%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__h"
        x1="48.63%"
        x2="51.99%"
        y1="47.718%"
        y2="52.883%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__i"
        x1="49.18%"
        x2="50.95%"
        y1="48.496%"
        y2="51.221%"
      >
        <stop offset="0%" stopColor="#8E071E" />
        <stop offset="25.88%" stopColor="#80061A" />
        <stop offset="74.25%" stopColor="#5D020F" />
        <stop offset="100%" stopColor="#470008" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__j"
        x1="33.375%"
        x2="81.082%"
        y1="15.408%"
        y2="99.824%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__k"
        x1="30.072%"
        x2="68.062%"
        y1="26.023%"
        y2="59.206%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__l"
        x1="5.395%"
        x2="78.805%"
        y1="-23.912%"
        y2="97.771%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__m"
        x1="30.857%"
        x2="48.331%"
        y1="19.365%"
        y2="58.935%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__n"
        x1="35.137%"
        x2="53.419%"
        y1="36.947%"
        y2="49.261%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__o"
        x1="4.1%"
        x2="77.649%"
        y1="-26.077%"
        y2="95.835%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__p"
        x1="32.693%"
        x2="63.34%"
        y1="44.046%"
        y2="61.545%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__q"
        x1="25.006%"
        x2="74.995%"
        y1="6.715%"
        y2="93.3%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__r"
        x1="24.988%"
        x2="74.977%"
        y1="6.715%"
        y2="93.3%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__s"
        x1="32.293%"
        x2="66.476%"
        y1="34.161%"
        y2="58.997%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__t"
        x1="36.814%"
        x2="53.651%"
        y1="41.273%"
        y2="58.505%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__u"
        x1="42.833%"
        x2="65.531%"
        y1="27.431%"
        y2="70.122%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__v"
        x1="42.359%"
        x2="65.141%"
        y1="35.971%"
        y2="57.516%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__w"
        x1="43.346%"
        x2="57.461%"
        y1="45.783%"
        y2="53.887%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__x"
        x1="-7.393%"
        x2="107.375%"
        y1="49.973%"
        y2="49.973%"
      >
        <stop offset="0%" stopOpacity={0} />
        <stop offset="100%" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__y"
        x1="-17.078%"
        x2="73.223%"
        y1="-9.653%"
        y2="80.945%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__z"
        x1="19.824%"
        x2="84.522%"
        y1="-3.342%"
        y2="106.447%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__A"
        x1="-12.793%"
        x2="112.685%"
        y1="50.13%"
        y2="50.13%"
      >
        <stop offset="0%" stopOpacity={0} />
        <stop offset="100%" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__B"
        x1="9.152%"
        x2="71.582%"
        y1="-4.947%"
        y2="94.753%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__C"
        x1="25.081%"
        x2="164.677%"
        y1="6.629%"
        y2="248.403%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__D"
        x1="25.068%"
        x2="74.703%"
        y1="6.432%"
        y2="92.419%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__E"
        x1="25.145%"
        x2="74.823%"
        y1="7.323%"
        y2="93.387%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__F"
        x1="25.149%"
        x2="74.797%"
        y1="7.608%"
        y2="93.595%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__G"
        x1="21.758%"
        x2="63.434%"
        y1="14.116%"
        y2="87.978%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__H"
        x1="34.609%"
        x2="64.212%"
        y1="23.86%"
        y2="79.012%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__I"
        x1="24.579%"
        x2="74.527%"
        y1="16.1%"
        y2="83.078%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__J"
        x1="39.763%"
        x2="57.071%"
        y1="11.649%"
        y2="81.766%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__K"
        x1="49.37%"
        x2="50.133%"
        y1="28.846%"
        y2="61.889%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__L"
        x1="31.845%"
        x2="71.804%"
        y1=".112%"
        y2="87.344%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__M"
        x1="24.075%"
        x2="70.935%"
        y1="28.462%"
        y2="72.913%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__N"
        x1="19.8%"
        x2="59.754%"
        y1="46.899%"
        y2="50.96%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__O"
        x1="-73.587%"
        x2="120.909%"
        y1="-158.125%"
        y2="184.01%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__P"
        x1="39.66%"
        x2="70.264%"
        y1="24.197%"
        y2="98.672%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__Q"
        x1="47.901%"
        x2="51.263%"
        y1="12.196%"
        y2="87.33%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__R"
        x1="38.754%"
        x2="66.346%"
        y1="9.772%"
        y2="66.788%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__S"
        x1="39.501%"
        x2="84.051%"
        y1="8.295%"
        y2="95.458%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__T"
        x1="47.95%"
        x2="54.11%"
        y1="46.907%"
        y2="55.34%"
      >
        <stop offset="0%" stopColor="#FE074E" />
        <stop offset="23.72%" stopColor="#F00641" />
        <stop offset="68.02%" stopColor="#CD031D" />
        <stop offset="100%" stopColor="#AF0000" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__U"
        x1="24.595%"
        x2="74.845%"
        y1="6.642%"
        y2="93.689%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__V"
        x1="24.737%"
        x2="74.171%"
        y1="7.526%"
        y2="93.132%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__W"
        x1="37.443%"
        x2="56.613%"
        y1="20.646%"
        y2="80.377%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__X"
        x1="36.537%"
        x2="64.232%"
        y1="45.004%"
        y2="57.513%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__Y"
        x1="27.312%"
        x2="77.502%"
        y1="24.916%"
        y2="78.074%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__Z"
        x1="29.959%"
        x2="62.239%"
        y1="16.271%"
        y2="79.499%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aa"
        x1="42.236%"
        x2="65.386%"
        y1="27.835%"
        y2="67.915%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ab"
        x1="44.195%"
        x2="66.725%"
        y1="27.165%"
        y2="66.195%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ac"
        x1="24.438%"
        x2="74.588%"
        y1="6.362%"
        y2="93.237%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ad"
        x1="24.211%"
        x2="74.711%"
        y1="6.316%"
        y2="93.789%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ae"
        x1="24.224%"
        x2="74.724%"
        y1="5.711%"
        y2="93.184%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__af"
        x1="24.276%"
        x2="74.776%"
        y1="6.211%"
        y2="93.684%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ag"
        x1="24.737%"
        x2="75.237%"
        y1="6.342%"
        y2="93.816%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ah"
        x1="25.158%"
        x2="75.658%"
        y1="6.355%"
        y2="93.829%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ai"
        x1="24.637%"
        x2="74.787%"
        y1="7.05%"
        y2="93.925%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aj"
        x1="25.038%"
        x2="75.2%"
        y1="6.275%"
        y2="93.15%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ak"
        x1="24.65%"
        x2="74.8%"
        y1="6.525%"
        y2="93.4%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__al"
        x1="23.618%"
        x2="74.501%"
        y1="6.498%"
        y2="93.124%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__am"
        x1="39.037%"
        x2="58.08%"
        y1="21.962%"
        y2="80.703%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__an"
        x1="38.179%"
        x2="72.905%"
        y1="13.686%"
        y2="91.022%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ao"
        x1="24.984%"
        x2="75.034%"
        y1="6.631%"
        y2="93.321%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ap"
        x1="25.879%"
        x2="74.98%"
        y1="27.157%"
        y2="80.924%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aq"
        x1="24.959%"
        x2="73.619%"
        y1="12.867%"
        y2="82.586%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ar"
        x1="37.679%"
        x2="61.593%"
        y1="32.305%"
        y2="66.503%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__as"
        x1="33.549%"
        x2="66.213%"
        y1="25.572%"
        y2="65.314%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__at"
        x1="32.152%"
        x2="67.999%"
        y1=".92%"
        y2="97.302%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__au"
        x1="37.602%"
        x2="62.272%"
        y1="27.527%"
        y2="74.928%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__av"
        x1="40.101%"
        x2="60.704%"
        y1="14.987%"
        y2="80.017%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aw"
        x1="38.805%"
        x2="66.271%"
        y1="44.825%"
        y2="55.28%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ax"
        x1="28.061%"
        x2="72.472%"
        y1="6.398%"
        y2="87.374%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ay"
        x1="40.046%"
        x2="59.903%"
        y1="42.201%"
        y2="52.71%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__az"
        x1="15.088%"
        x2="59.58%"
        y1="-33.007%"
        y2="71.974%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aA"
        x1="34.138%"
        x2="65.308%"
        y1="10.302%"
        y2="97.598%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aB"
        x1="22.631%"
        x2="77.256%"
        y1="7.75%"
        y2="91.861%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aC"
        x1="29.088%"
        x2="60.137%"
        y1="6.949%"
        y2="92.102%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aD"
        x1="28.427%"
        x2="65.805%"
        y1="29.025%"
        y2="69.811%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aE"
        x1="12.908%"
        x2="79.179%"
        y1="-46.218%"
        y2="93.26%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aF"
        x1="47.95%"
        x2="54.11%"
        y1="46.09%"
        y2="56.75%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aG"
        x1="48.905%"
        x2="50.989%"
        y1="10.334%"
        y2="90.683%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aH"
        x1="21.49%"
        x2="64.842%"
        y1="12.595%"
        y2="78.915%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aI"
        x1="24.947%"
        x2="74.56%"
        y1="21.273%"
        y2="79.886%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aJ"
        x1="25.146%"
        x2="75.383%"
        y1="6.588%"
        y2="93.615%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aK"
        x1="25.121%"
        x2="75.368%"
        y1="6.533%"
        y2="93.56%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aL"
        x1="36.36%"
        x2="62.48%"
        y1="19.567%"
        y2="82.351%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aM"
        x1="40.999%"
        x2="63.649%"
        y1="27.739%"
        y2="83.22%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aN"
        x1="27.921%"
        x2="74.007%"
        y1="4.91%"
        y2="94.478%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aO"
        x1="45.19%"
        x2="51.452%"
        y1="10.253%"
        y2="84.34%"
      >
        <stop offset="0%" stopColor="#E8F2F2" />
        <stop offset="100%" stopColor="#C2CCCC" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aP"
        x1="36.026%"
        x2="64.187%"
        y1="44.76%"
        y2="54.387%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aQ"
        x1="15.418%"
        x2="64.968%"
        y1="20.073%"
        y2="86.673%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aR"
        x1="-5.615%"
        x2="80.345%"
        y1="-46.275%"
        y2="102.613%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aS"
        x1="24.921%"
        x2="74.889%"
        y1="6.682%"
        y2="93.232%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aT"
        x1="2.353%"
        x2="69.993%"
        y1="21.986%"
        y2="60.793%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aU"
        x1="-104.302%"
        x2="78.208%"
        y1="-217.521%"
        y2="98.583%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aV"
        x1="-83.542%"
        x2="109.969%"
        y1="-180.438%"
        y2="154.74%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aW"
        x1="-21.843%"
        x2="85.193%"
        y1="-74.217%"
        y2="111.171%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aX"
        x1="24.68%"
        x2="74.905%"
        y1="6.559%"
        y2="93.554%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aY"
        x1="24.762%"
        x2="74.5%"
        y1="7.024%"
        y2="93.175%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__aZ"
        x1="31.355%"
        x2="77.784%"
        y1="12.346%"
        y2="88.954%"
      >
        <stop offset="0%" stopColor="#C8D2D2" />
        <stop offset="19.25%" stopColor="#BAC4C4" />
        <stop offset="55.37%" stopColor="#96A0A0" />
        <stop offset="100%" stopColor="#626C6C" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__ba"
        x1="24.918%"
        x2="74.439%"
        y1="7.235%"
        y2="93.02%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
      <linearGradient
        id="icon-motorcycle-off_svg__bb"
        x1="19.066%"
        x2="78.276%"
        y1="10.276%"
        y2="90.142%"
      >
        <stop offset="0%" stopColor="#DCE6E6" />
        <stop offset="19.25%" stopColor="#CED8D8" />
        <stop offset="55.37%" stopColor="#AAB4B4" />
        <stop offset="100%" stopColor="#768080" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0-6h155v94H0z" />
      <g opacity={0.6}>
        <path
          fill="url(#icon-motorcycle-off_svg__a)"
          fillRule="nonzero"
          d="M59.932 65L57 70.246 63.103 73 64 71.186z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__b)"
          fillRule="nonzero"
          d="M50.675 60.227l1.416-.095c-.361-.663-.833-2.03-.833-2.03-.305.176-1.068-.136-1.068-.136s-3.025-6.05-4.524-7.376c-1.499-1.327 0 0 0 0l.735-.136s2.623 3.276 3.872 6.633c0 0 .194.595.86.595 0 0 5.717.027 6.12 0 .402-.027.319-.162.319-.162s.222.758 1.387.758c0 0-.041.298-.097.46 0 0 .514.203 1.138.176 0 0-.36.907-.36 1.935 0 1.03 0 0 0 0L51.021 62c0-.027-.139-1.083-.347-1.773z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__c)"
          fillRule="nonzero"
          d="M46 50.36s2.464 3.362 3.737 7.01c.134.372.455.63.83.63h5.787c.415 0 .723-.4.63-.83l-1.032-4.965L51.062 49 46 50.36"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__d)"
          fillRule="nonzero"
          d="M106.472 42.3s.742-1.04.467-1.622c-.275-.581-1.141-.946-1.141-.946l.536-1.244a.293.293 0 0 0-.096-.352l-.44-.31.55-1.204a.297.297 0 0 0-.11-.379l-.385-.243L97 53.807s1.045.744 1.292 1.055c.261.31 0 0 0 0l6.722-13.48 1.458.919"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__e)"
          fillRule="nonzero"
          d="M88.8 37c-1.443 0-2.996.655-3.216.75-.234.192-.48.41-.742.642L62.551 58.644a4.728 4.728 0 0 0-.908 5.881l4.37 7.465.454.041c.07-.491.468-.873.976-.928l-2.35-4.217a1.071 1.071 0 0 1-.825-.109 1.101 1.101 0 0 1-.55-.71 1.11 1.11 0 0 1 1.086-1.364c.413 0 .784.232.976.56l10.624 4.612s-.014 0-.014.014c.247-.219.467-.383.605-.396.426-.068 3.27.928 3.614 1.747.124.3.124.573.041.805h.248c-.11-.519-.206-1.037-.22-1.242-.055-.478-.138-.628 0-.682.137-.069 1.47.095 1.951.163.481.069.852.341 1.608.355.742.014 1.059-.41 1.553-.723.495-.314.66-.369 1.086-.41.426-.04.618.11.687.533.055.327-1.649 2.401-3.765 2.374 0 0 .81.096 1.58.587 1.14-.014 2.749-.11 2.749-.11l.37-.9-.15-.45.55-.56h.412l.137-.614s.618.055.907 0c.275-.054.454-.164.481-.327.028-.164-.302-.628-.302-.628h3.284l1.045-2.17v-.014c0-1.105-.138-1.746-.179-1.965-.041-.218-.495-.204-.495-.204.784-3.44 3.491-4.654 3.491-4.654.33-.914.591-1.706.646-2.115.151-1.242-.907-2.361-.907-2.361l-1.897 3.835s-.178-.041-.44-.137a.996.996 0 0 0-.55-.232 3.855 3.855 0 0 1-.563-.34s4.742-9.895 5.8-11.996c1.058-2.102 2.405-4.627 3.93-7.588.097-.191.207-.396.303-.614-.055 0-14.527-1.856-15.2-1.856zm-4.192 13.62l-.453.218-.028-.56c-.824-.164-2.116-.109-2.556-.109-.44 0-1.333.205-2.048.123-.714-.082-1.237-.287-1.965-.232-.728.068-1.635 1.501-1.635 1.501-1.333-.887-3.161-1.72-3.161-1.72.11-.313 1.168-.682 1.168-.682l.11.546s.948 0 1.553-.068 1.635-.874 1.635-.874l3.477-.368.88-.532h1.333l.289.505 1.401.573.385-.055.069.437-.454 1.296zm16.107-5.446l-2.061 1.938-.028-2.156-1.223-1.924-.494-.191s.343-1.515.604-2.498c.261-.968 0-1.473 0-1.473v-.82l3.463.437-.26 6.687z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__f)"
          fillRule="nonzero"
          d="M98 46.11l-1.462-.525a1.47 1.47 0 0 0 .054-.417 1.75 1.75 0 0 0-1.759-1.748c-.69 0-1.286.404-1.583.982l-3.397-1.237c.027-.135.054-.269.054-.417A1.75 1.75 0 0 0 88.147 41c-.69 0-1.285.39-1.57.968l-1.42-.51s-.163.241 0 .443l-.745 3.254.826 3.039s-.271.229-.122.524l-.42 1.399-1.434-.498a.146.146 0 0 0-.19.094l-.149.565-1.529-.551-1.15.013-.244.646.96.726 1.381.551.082.47 1.65.485.028 1.062-.61 1.815s.136.619.082 1.237l.392.39.19.108c.054-.013.108-.027.162-.027a.62.62 0 0 1 .271.067c.122-.013.244-.013.379-.013 1.177 0 2.233.457 3.018 1.21.04-.013.068-.013.108-.013.298 0 .542.242.542.538a.537.537 0 0 1-.041.201c.162.242.298.498.406.767l.068.04.947-1.533c.108-.175.284-.31.474-.39l1.448-.538-1.191-.282 3.045-4.64.203-.308s.217-.04.298-.189c.094-.188.027-.322.027-.322L98 46.11z"
        />
        <g fillRule="nonzero">
          <path
            fill="url(#icon-motorcycle-off_svg__g)"
            d="M1.499 4.12c.505.077 14.15 1.72 14.573 1.77l.341-.757c-.013-.064-.082-.27-.45-.551-.45-.334-6.018-4.12-6.304-4.287C9.372.128 8.84.103 8.403.193L1.267 3.425c0 .013-.273.617.232.694z"
            transform="translate(87 31)"
          />
          <path
            fill="url(#icon-motorcycle-off_svg__h)"
            d="M15.84 6.391h.014l.054-.128z"
            transform="translate(87 31)"
          />
          <path
            fill="url(#icon-motorcycle-off_svg__i)"
            d="M1.24 3.44l-.587.269v.013z"
            transform="translate(87 31)"
          />
        </g>
        <path
          fill="url(#icon-motorcycle-off_svg__j)"
          fillRule="nonzero"
          d="M103.006 27l1.964 4.067c.04.067.04.162 0 .23l-1.22 2.63c-.027.067-.12.095-.173.054-.743-.542-4.803-3.484-5.095-3.66-.558-.352-.478-.854-.478-.854"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__k)"
          fillRule="nonzero"
          d="M63.371 55L80 40l-29 7.628z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__l)"
          fillRule="nonzero"
          d="M132 43c-12.707 0-23 10.07-23 22.5S119.293 88 132 88s23-10.07 23-22.5S144.693 43 132 43zm0 37.21c-8.296 0-15.037-6.581-15.037-14.71 0-8.115 6.728-14.71 15.037-14.71 8.31 0 15.037 6.581 15.037 14.71-.013 8.129-6.741 14.71-15.037 14.71z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__m)"
          fillRule="nonzero"
          d="M119 48.688s-.657-1.417-1.273-2.298c-.509-.716-.87-1.101-.991-1.39-4.408 3.33-7.597 8.271-8.736 13.982 1.983.22 2.76-1.692 2.76-1.692a23.147 23.147 0 0 1 5.105-7.583 1.73 1.73 0 0 1 2.264-.152l.47.358.347-.165c-.214-.248-.335-.716.054-1.06z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__n)"
          fillRule="nonzero"
          d="M130.958 42c-3.564 0-6.93.789-9.958 2.183.282.31.803.958 1.028 1.775.31 1.14.535 1.436 1.014 2.338 0 0 .38-.226.775-.141.366.07.62.465.563.845l.268-.127.098-1.55a1.82 1.82 0 0 1 1.339-1.661 23.681 23.681 0 0 1 6.352-.86c.887 0 1.76.057 2.62.142 3.59.126 3.943-1.536 3.943-1.55A23.83 23.83 0 0 0 130.958 42z"
        />
        <path
          fill="#F96D67"
          fillRule="nonzero"
          d="M33.935 35.735v-.02c0-.25-.2-.45-.45-.45-.19 0-.35.12-.42.29.3.06.6.12.87.18z"
        />
        <path
          fill="#AF0000"
          fillRule="nonzero"
          d="M16.915 36.42a.448.448 0 0 0-.81.37c.26-.13.53-.25.81-.37z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__o)"
          fillRule="nonzero"
          d="M28 43C15.293 43 5 53.07 5 65.5S15.293 88 28 88s23-10.07 23-22.5S40.707 43 28 43zm0 37.21c-8.296 0-15.037-6.581-15.037-14.71 0-8.115 6.728-14.71 15.037-14.71 8.31 0 15.037 6.581 15.037 14.71 0 8.129-6.741 14.71-15.037 14.71z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__p)"
          fillRule="nonzero"
          d="M42.646 43.609c-1.264-.733-4.298-5.591-4.705-6.936 0 0-6.672-2.635-14.65-1.29C15.54 36.7 8.503 42.223 6.032 47.175c-.1.186.055.413.28.413 1.25-.014 4.832-.054 9.073-.187.169 0 .337-.053.492-.133.927-.506 4.69-2.37 9.761-2.37 5.689 0 10.646 1.997 15.83 5.512a3.46 3.46 0 0 0 2.752.492L52 49.04c-4.593-2.663-8.96-5.205-9.354-5.431z"
        />
        <circle
          cx={27.5}
          cy={66.5}
          r={14.5}
          fill="url(#icon-motorcycle-off_svg__q)"
          fillRule="nonzero"
        />
        <circle
          cx={132.5}
          cy={66.5}
          r={14.5}
          fill="url(#icon-motorcycle-off_svg__r)"
          fillRule="nonzero"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__s)"
          fillRule="nonzero"
          d="M65.248 40.22s.724-.88.752-1.219c.013-.176-.246-.934-1.722-1.313-1.488-.38-5.313.311-6.242.406-.928.095-6.365.203-9.424-.989-3.06-1.191-6.092-3.21-7.28-3.1-1.189.108-1.435 1.11-1.298 2.22.136 1.11 3.305 5.512 5.764 7.123 2.459 1.612 3.674 2.032 6.939 1.314 3.264-.718 9.602-2.898 9.602-2.898s1.352-.474 1.885-.69c.519-.244 1.024-.854 1.024-.854z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__t)"
          fillRule="nonzero"
          d="M100.63 26.063a.781.781 0 0 0 .23-1.11c-1.056-1.494-3.75-5.022-6.2-5.656-3.126-.806-9.461-.225-15.241 4.969a362.174 362.174 0 0 0-10.558 9.858c-.596.581-1.15 1.387-1.286 2.683-.135 1.295-.19 2.867-.555 3.184-.365.317-1.232.357-1.232.357s-.392.542-.92.753c-.528.225-1.868.674-1.868.674s.352 0 .433.225c0 0 15.458-4.044 15.986-4.19.528-.144 2.017-.647 3.046-1.69 1.028-1.045 2.179-1.917 3.952-2.75 2.247-1.07 10.436-4.968 14.213-7.307z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__u)"
          fillRule="nonzero"
          d="M105.436 23l-19.204 9.827a8.758 8.758 0 0 0-2.081 1.474L61.098 56.096c-2.23 2.113-2.747 5.533-1.238 8.23L65.273 74s.884-.111 1.714-.917l-5.48-9.689a4.857 4.857 0 0 1 .883-5.907l22.305-20.879a15.817 15.817 0 0 1 3.863-2.669L107 24.877"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__v)"
          fillRule="nonzero"
          d="M54.289 48.605l8.058 5.223c.396.26.915.219 1.27-.082l11.228-9.626a3.993 3.993 0 0 0 1.134-1.627c.096-.274-.15-.56-.437-.479l-21.076 5.483a.608.608 0 0 0-.177 1.108z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__w)"
          fillRule="nonzero"
          d="M81 37l-32 9.179 1.272.821 29-8.3z"
        />
        <path
          stroke="url(#icon-motorcycle-off_svg__x)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M41 34s.472 1.38 1.792 2.637c1.32 1.256 3.597 3.77 7.07 5.027C53.332 42.92 54.263 43.426 55 44"
          opacity={0.5}
        />
        <circle cx={33.5} cy={45.5} r={1} fill="#DCE6E6" fillRule="nonzero" />
        <circle cx={19.5} cy={44.5} r={1} fill="#DCE6E6" fillRule="nonzero" />
        <path
          fill="#DCE6E6"
          fillRule="nonzero"
          d="M33.935 35.735v-.02c0-.25-.2-.45-.45-.45-.19 0-.35.12-.42.29.3.06.6.12.87.18zm-17.02.685a.448.448 0 0 0-.81.37c.26-.13.53-.25.81-.37z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__y)"
          fillRule="nonzero"
          d="M9.362 41.592s.076-.519.289-.79c.213-.26.624-.655.076-1.568S7.414 37.013 5.603 37c-1.416-.012-2.223.358-2.496.506A.19.19 0 0 0 3 37.68c.06.593.32 3.431.365 3.69.061.297.609.654 1.142.63.532-.025 1.004-.358 1.4-.432.396-.074.76 0 .76 0l.016.296"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__z)"
          fillRule="nonzero"
          d="M3.654 37l-3.502.258c-.083 0-.152.067-.152.162 0 .53.028 2.427.29 3.295A.414.414 0 0 0 .693 41L4 40.919 3.654 37z"
        />
        <path
          stroke="url(#icon-motorcycle-off_svg__A)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M57 55.5h-8"
          opacity={0.5}
        />
        <path
          fill="url(#icon-motorcycle-off_svg__B)"
          fillRule="nonzero"
          d="M59.71 59h-1.362c-.45 0-1.16-.094-1.45-.748 0 0 .305-.254.218-.615L56 53l6 3.394S60.391 57.57 59.71 59z"
        />
        <circle
          cx={50.5}
          cy={51.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__C)"
          fillRule="nonzero"
        />
        <circle
          cx={51.5}
          cy={51.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__D)"
          fillRule="nonzero"
        />
        <circle
          cx={45.5}
          cy={49.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__E)"
          fillRule="nonzero"
        />
        <circle
          cx={45.5}
          cy={49.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__F)"
          fillRule="nonzero"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__G)"
          fillRule="nonzero"
          d="M43.013 56.075l2.885 2.532a.314.314 0 0 1 .028.434L44.49 60.72c-.287.336-.67.587-1.08.713l-1.614.504c-1.039.322-2.023-.644-1.75-1.707l.301-1.203a2.15 2.15 0 0 1 .465-.896l1.764-2.014c.123-.14.314-.154.437-.042z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__H)"
          fillRule="nonzero"
          d="M31 59.168L38.052 50 40 51.34 33.324 60z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__I)"
          fillRule="nonzero"
          d="M38.03 48.204c.298.369 1.544 1.58 4.108 2.777.071.04.156.013.213-.04l1.544-1.684a.393.393 0 0 0 .028-.5 8.303 8.303 0 0 0-4.037-2.737.448.448 0 0 0-.496.158l-1.346 1.855c-.056.04-.056.105-.014.171z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__J)"
          fillRule="nonzero"
          d="M41.252 46l-.08-.678c-.04-.34.01-.679.14-.971l.15-.351.38.292-.19.433a.96.96 0 0 0-.08.41v.35l-.32.515z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__K)"
          fillRule="nonzero"
          d="M49.802 66.49a1.895 1.895 0 0 1-.403-.2l-2.288-1.516a2.153 2.153 0 0 0-.39-.2L31.355 59S30.48 63.031 29 66.543l15.716 3.898c.121.027.256.053.39.053l3.324.12c.175 0 .35.04.525.093l.888.293c.673-.945 1.157-4.084 1.157-4.084l-1.198-.426z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__L)"
          fillRule="nonzero"
          d="M30.073 59.005l-4.46.288c-.116.013-.218.082-.247.191-.376 1.506-.376 4.723-.362 5.545a.37.37 0 0 0 .174.3l2.752 1.52a.663.663 0 0 0 .231.083l.305.068C30.044 63.386 31 59.238 31 59.238l-.565-.192a.823.823 0 0 0-.362-.04z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__M)"
          fillRule="nonzero"
          d="M50.132 71.45c.423.447 6.768 2.495 7.205 2.594.449.1 1.123.137 1.123.137l2.274.819c.45-.161.846-.62 1.137-1.316.29-.695 0-1.315 0-1.315l-2.3-.881s-.291-.398-.952-.708c-.661-.31-5.156-2.023-5.817-2.32-.66-.299-1.652-.46-1.652-.46s-.463 2.619-1.15 3.649"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__N)"
          fillRule="nonzero"
          d="M50 66.157s11.503-.01 11.517 0l.483.6-9.486.09-1.037-.17-.014-.14-1.335-.34-.128-.04z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__O)"
          fillRule="nonzero"
          d="M53 66.99c.275-.317.066-.875.066-.875l.815-.115s.17.529.104 1L53 66.99z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__P)"
          fillRule="nonzero"
          d="M117.544 44.415s-.544.625-.544.937c0 .312.433.692 1.074 1.547.642.869 1.326 2.267 1.326 2.267-.586.502-.028 1.235.237 1.194.265-.04.559 0 .824.163.265.163 10.493 16.926 10.703 17.197.209.272.823 1.683 1.758 1.168.935-.503 1.493-.706 1.842-.978.349-.271.279-1.045 0-1.438-.28-.408-9.768-15.61-10.117-16.234-.349-.624-.74-1.425-.74-1.425.056-.299.363-.461.503-.869.125-.393-.154-.841-.544-.923-.391-.081-.768.136-.768.136-.474-.868-.684-1.154-1.005-2.253-.307-1.1-1.2-1.887-1.2-1.887-.377-.081-.893.15-.893.15l.07.122s-.935.869-2.442 1.249l-.084-.123z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__Q)"
          fillRule="nonzero"
          d="M118.039 18s.71.606.89 3.574c.18 2.968-.44 5.936-.87 6.426l-.02-10z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__R)"
          fillRule="nonzero"
          d="M113 30.41l2.136-2.41s.427.139.79.154c.35.016 1.074.016 1.074.016L113.75 32l-.75-1.59z"
        />
        <g fillRule="nonzero">
          <path
            fill="url(#icon-motorcycle-off_svg__S)"
            d="M.229 4.498S1.814 1.93 4.343.712L8.37.445c.229-.013.443.14.458.355l.014 10.318s-.786 0-1.186-.013a5.108 5.108 0 0 1-.871-.127l-.486.406-1.8-.063s-.729-.038-1.214-.178L.514 6.747S.943 5.87.9 5.59C.843 5.273.229 4.498.229 4.498z"
            transform="translate(108 17)"
          />
          <path
            fill="url(#icon-motorcycle-off_svg__T)"
            d="M8.829 11.105l-.386.343c.2-.013.371-.152.386-.343z"
            transform="translate(108 17)"
          />
        </g>
        <circle cx={94} cy={60} r={1} fill="url(#icon-motorcycle-off_svg__U)" fillRule="nonzero" />
        <circle
          cx={93.5}
          cy={59.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__V)"
          fillRule="nonzero"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__W)"
          fillRule="nonzero"
          d="M104.709 26.965l1.635 3.087s-1.995 5.765-3.533 8.716c-1.538 2.95-2.896 5.466-3.963 7.56C97.78 48.422 93 58.279 93 58.279c.18.136.374.245.568.354.208.027.402.109.554.231.264.095.444.136.444.136s7.76-15.528 8.342-16.697c.582-1.156 2.258-4.42 2.882-5.752.623-1.332 2.23-5.03 2.23-5.03l1.442 2.692s.984-.3 1.538-.803L106.76 26l-2.051.965z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__X)"
          fillRule="nonzero"
          d="M85 36.77s1.6-.862 3.094-.862c.655 0 14.5 2.092 14.5 2.092l.406-1.046s-13.516-2.03-14.015-2.123c-.498-.093-.222-.831-.222-.831l-1.233.723A10.74 10.74 0 0 0 85 36.769z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__Y)"
          fillRule="nonzero"
          d="M96 30.91c.46-.092 1.02-.066 1.323.105.302.172 6.167 4.062 6.642 4.405.474.343.489.58.489.58l.546-1.24s-.388-.026-.92-.369l-5.636-3.626s-.388-.185-.417-.765L96 30.91z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__Z)"
          fillRule="nonzero"
          d="M94 53.575l-3.18 4.412s-.354.051-.82-.05l1.23-3.019c.127-.307.268-.588.438-.882L92.276 53l1.724.575z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aa)"
          fillRule="nonzero"
          d="M83.706 50.299s-.31-.07-.39.07c-.07.14.05.26.05.26l.24.09.1-.42z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__ab)"
          fillRule="nonzero"
          d="M80.7 50.262s-.33-.04-.39.13.21.35.21.35l.18-.48z"
        />
        <circle
          cx={89.5}
          cy={63.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ac)"
          fillRule="nonzero"
        />
        <circle
          cx={82.5}
          cy={55.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ad)"
          fillRule="nonzero"
        />
        <circle
          cx={79.5}
          cy={52.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ae)"
          fillRule="nonzero"
        />
        <circle
          cx={76.5}
          cy={51.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__af)"
          fillRule="nonzero"
        />
        <circle
          cx={72.5}
          cy={52.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ag)"
          fillRule="nonzero"
        />
        <circle
          cx={69.5}
          cy={55.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ah)"
          fillRule="nonzero"
        />
        <circle
          cx={88.5}
          cy={59.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ai)"
          fillRule="nonzero"
        />
        <circle
          cx={84.5}
          cy={58.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__aj)"
          fillRule="nonzero"
        />
        <circle
          cx={86.5}
          cy={66.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ak)"
          fillRule="nonzero"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__al)"
          fillRule="nonzero"
          d="M89.56 63.129c.141 0 .27.056.369.14a4.41 4.41 0 0 0-.697-3.27.566.566 0 0 1-1.095-.196c0-.28.2-.503.455-.545A4.608 4.608 0 0 0 85.408 58c-.128 0-.27 0-.399.014.171.098.3.28.3.49a.566.566 0 0 1-.57.558.566.566 0 0 1-.568-.559c0-.14.056-.28.142-.377a4.678 4.678 0 0 0-1.706.81c.028.21.028.434.028.657 0 1.607-.611 3.06-1.635 4.165C81.555 65.63 83.318 67 85.393 67c.228 0 .441-.014.654-.042a.562.562 0 0 1-.113-.335c0-.308.256-.56.568-.56.313 0 .57.252.57.56v.07a4.63 4.63 0 0 0 2.544-2.432c-.028 0-.057.014-.071.014a.566.566 0 0 1-.569-.56c0-.335.256-.586.583-.586z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__am)"
          fillRule="nonzero"
          d="M88 75s3.836-.296 5.609-2.383c1.785-2.086 5.476-10.554 6.045-12.492.555-1.925.357-3.594 0-4.321-.357-.727-1.839-1.804-1.839-1.804l-.82 1.71s1.019 1.09.873 2.328c-.145 1.225-2.024 5.681-2.54 6.92-.516 1.225-2.037 5.357-3.664 6.61-1.627 1.251-3.492.982-3.492.982s.33 1.44-.172 2.45z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__an)"
          fillRule="nonzero"
          d="M103.96 20s-1.332.56-1.96 1.18l.689 1.374.474-.178.184.296s-.444.25-.306.56c.138.31.566.074.566.074l.352.694.98-.472s-.49-.96.061-1.624L103.96 20z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__ao)"
          fillRule="nonzero"
          d="M82.435 58.413c.175-.135.363-.256.565-.363a6.503 6.503 0 0 0-2.984-5.028h-.014a.507.507 0 0 1-.457-.283A6.386 6.386 0 0 0 76.977 52a.513.513 0 0 1-.47.323.499.499 0 0 1-.47-.323A6.506 6.506 0 0 0 70 58.493 6.512 6.512 0 0 0 76.507 65a6.45 6.45 0 0 0 4.476-1.788c-.013-.054-.04-.121-.053-.175a5.97 5.97 0 0 0 1.546-4.006l-.04-.618z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__ap)"
          fillRule="nonzero"
          d="M79.632 72.038s1.214.872 1.328 1.1c.158.341-.185.632-.471.759-.286.126-1.5.1-1.5.1h-1.386c-.414 0-.772-.163-.914-.303 0 0-.358.064-.9-.316-.543-.379-1.6-1.176-1.715-1.53-.114-.354-.114-.784.129-1.05.243-.265 1.743-1.732 2.186-1.795.442-.063 3.4.86 3.757 1.619.286.632-.1 1.125-.514 1.416z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aq)"
          fillRule="nonzero"
          d="M74.456 72.227c-.104-.4-.104-.887.117-1.187.156-.215.87-1.088 1.427-1.617l-10.028-4.836c-.182-.358-.519-.587-.921-.587-.584 0-1.051.515-1.051 1.159s.467 1.159 1.05 1.159a.89.89 0 0 0 .273-.043l2.219 4.421c-.52.072-.934.558-.934 1.145 0 .644.467 1.159 1.05 1.159a1 1 0 0 0 .844-.472l6.136.057a2.05 2.05 0 0 1-.182-.358z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__ar)"
          fillRule="nonzero"
          d="M102.408 15.158l1.256-.158s.359.408.335.975c-.024.579-.371.698-.694.777-.335.079-1.328 0-1.663 0-.335 0-.43.25-.43.25s.19.448-.097.803c-.215.25-.586.25-.825.053-.24-.198-.443-.698-.132-1.238.323-.58 1.101-.882 2.297-.75l-.047-.712z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__as)"
          fillRule="nonzero"
          d="M101.674 12.347l-1.657.183c-1.278-.606-2.36-.507-2.88-.24-.435.212-.954.705-1.137 1.227l.351-.056.281-.043c.407-.056.267-.084.407-.084.674 0 1.208.606 1.208 1.353S97.7 16.04 97.04 16.04c-.126 0-.407-.085-.407-.085l-.295.043c.084.352.155.606.155.606-.14.634-.07 1.296.337 1.38.407.085.702-.21.702-.21l.239.21c1.053-.084 2.092-.436 2.092-.436-.14-.268-.168-.648.07-1.043.38-.62 1.293-.944 2.697-.803l-.042-.747 1.475-.17s.323.325.379.818c1.25-1.1 1.559-2.185 1.559-2.185v-2.382c-2.95-.296-4.326 1.311-4.326 1.311z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__at)"
          fillRule="nonzero"
          d="M109.581 24s-.28.918-1.31 1.08L107 24.77 117.66 44c1.417-.324 2.34-1.242 2.34-1.242L109.581 24"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__au)"
          fillRule="nonzero"
          d="M50.12 51.518c0-.196.072-.364.173-.518L44 58.061l1.025.939L51 52.373c-.476 0-.88-.378-.88-.855z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__av)"
          fillRule="nonzero"
          d="M45.31 49.825c-.435 0-.792-.373-.792-.825l-.908 3.94a1.09 1.09 0 0 1-.204.425L42 55.148l.971.852 1.393-1.663c.166-.2.294-.44.37-.693L46 49.373a.768.768 0 0 1-.69.452z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aw)"
          fillRule="nonzero"
          d="M58.362 62.024V62L43 63.839l3.314 1.074c.136.048.272.108.394.18l1.535.907L59 64.65v-.011a5.055 5.055 0 0 1-.638-2.615z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__ax)"
          fillRule="nonzero"
          d="M51.767 50L51 51.03a.668.668 0 0 1 .544-.293c.378 0 .69.327.69.725 0 .21-.09.398-.234.538 0 0 .367-.047 1-1.205L51.767 50z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__ay)"
          fillRule="nonzero"
          d="M83.759 34.928a9.302 9.302 0 0 1 2.107-1.412l10.051-4.863s-.04-.387.083-.653c-3.924 2.038-8.496 4.197-10.107 4.956-1.804.853-2.988 1.732-4.02 2.772-1.047 1.052-2.548 1.558-3.099 1.705-.55.147-16.261 4.224-16.261 4.224-.083-.227-.44-.227-.44-.227s-6.39 2.145-9.68 2.851c-3.292.706-4.503.293-6.996-1.292-2.478-1.586-5.673-5.916-5.81-7.008-.028-.173-.028-.333-.028-.493l-.206-.04c-.62.453-.234 1.319-.234 1.319s1.68 3.437 2.795 4.583c1.666 1.692 4.819 3.438 4.819 3.438L48.771 46l31.876-8.34 3.112-2.732z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__az)"
          fillRule="nonzero"
          d="M6.236 47.961a.3.3 0 0 1-.272-.43c.843-1.833 2.256-3.735 4.036-5.498 0 0-2.147-.236-4.076.555-1.916.792-3.22 2.124-3.22 2.124s-.694 4.263-.911 5.262c-.218 1-.761 3.402-.788 3.707-.028.305.067.347.271.305.204-.055 2.134-1.04 2.297-1.152.176-.11.19-.61.19-.61s.611.04.734-.403c.122-.445.176-1.097.176-1.097s.408.11.625-.306c.218-.416.816-1.874.816-1.874l1.141-.583H6.236z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aA)"
          fillRule="nonzero"
          d="M100.694 12l.51-.054c.214-.254.796-.589.796-.589v-.696l-.128-.817s.043-1.956-.184-2.518c-.228-.563-2.074-2.37-2.074-2.37.157-2.036-.156-3-.156-3C98.678 0 97.47 0 97.47 0c-1.49 1.045-2.229 3.656-2.428 5.585-.199 1.928.37 2.17.37 2.17s.369.174.95.107c.583-.067 1.804-.71 1.804-.71l.824-.924s.54.361 1.178 1.004c.64.656.696 1.139.696 1.139v1.526l-.17.764V12z"
        />
        <circle cx={93} cy={15} r={1} fill="url(#icon-motorcycle-off_svg__aB)" fillRule="nonzero" />
        <path
          fill="url(#icon-motorcycle-off_svg__aC)"
          fillRule="nonzero"
          d="M97.71 12a1.17 1.17 0 0 0-.71.25.901.901 0 0 1 .382-.083c.631 0 1.131.597 1.131 1.333s-.513 1.333-1.131 1.333A.901.901 0 0 1 97 14.75c.21.167.447.25.71.25.711 0 1.29-.68 1.29-1.514 0-.805-.579-1.486-1.29-1.486z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aD)"
          fillRule="nonzero"
          d="M96.74 13a1.16 1.16 0 0 0-.571.15L93 13.614c.571 0 1.039.545 1.039 1.227 0 .559-.312 1.009-.753 1.159l3.026-.41c.13.042.272.083.415.083.701 0 1.273-.6 1.273-1.337.013-.736-.56-1.336-1.26-1.336z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aE)"
          fillRule="nonzero"
          d="M108.654 12.406c-.759-.162-2.263-.325-3.022-.406v.514c.974.068 3.108.325 3.652.555.773.325 1.146.799 1.074 1.814 0 0-.014-.718-.86-.934-1.46-.352-3.837.568-3.837.568s.115-.379.115-.568c0-.19-.158-.433-.745-.23-.23.311-.544.663-.974 1.001.015.068.015.15.015.23a1.772 1.772 0 0 1-.072.339c.129.067.3.108.516.04.5-.135.873-.365.873-.365s.917 1.286 1.06 1.516c0 0-.76-.325-1.99-.082l.644.745c.673-.054 1.69-.054 1.919.365.186.339.229.65.229.853.071.081.129.162.171.244.358.88.1 1.705.1 1.705l.258.392.702.298s2.349-4.209 2.506-6.104c.158-1.894-1.289-2.273-2.334-2.49zm-.3 6.537c-.201-2.287-2.02-3.952-2.02-3.952s2.979-1.029 3.308-.122c.444 1.218-1.289 4.074-1.289 4.074z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aF)"
          fillRule="nonzero"
          d="M117.635 28.365l-.27.27a.29.29 0 0 0 .27-.27z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aG)"
          fillRule="nonzero"
          d="M117.632 17l-.632.087s.154 6.485 0 11.842c.077.028.17.042.254.057.208.014.64.014.64.014.215-4.057.046-9.97-.008-11.6-.016-.242-.124-.413-.254-.4z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aH)"
          fillRule="nonzero"
          d="M105.329 22.27c0-.535.53-1.105 1.058-1.287.426-.148 1.29-.194 1.613-.217L106.735 19s-1.896 0-2.735 1.288l.877 1.458s-.464.388-.051 1.254l.606-.262c-.051-.16-.103-.32-.103-.467z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aI)"
          fillRule="nonzero"
          d="M107.823 18.885c-.215-.539-1.195-.872-1.88-1.039L104.4 16c-.134.09-.309.141-.483.167-.376.077-1.49 0-1.866 0-.376 0-.484.243-.484.243s.215.436-.107.782c-.12.129-.282.18-.456.193 0 0-.027.577.094.782.12.205.859 1.012.859 1.012.201-.09.564-.064.644 0 .08.065.537.565.537.565-.322.218-.416.705-.416.705l.416.551c.484-.282.967-.487.967-.487.873-1.449 2.846-1.449 2.846-1.449l.953 1.449c.014-.013.255-.808-.08-1.628z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aJ)"
          fillRule="nonzero"
          d="M95 45c-.55 0-1 .45-1 1s.45 1 1 1c.56 0 1-.45 1-1a.99.99 0 0 0-1-1zm0 1.418a.417.417 0 1 1 0-.835.417.417 0 0 1 0 .835z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aK)"
          fillRule="nonzero"
          d="M89 41c-.56 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.44-1-1-1zm0 1.418a.417.417 0 1 1 0-.835.417.417 0 0 1 0 .835z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aL)"
          fillRule="nonzero"
          d="M107.948 43.007l-6.745 12.713c-.118.232-.428.341-.68.245L98 55.051 105.453 41l2.303 1.365a.49.49 0 0 1 .192.642z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aM)"
          fillRule="nonzero"
          d="M99.68 59.717c-.332 1.108-1.692 4.349-3.162 7.34 0 0-.333 1.427-1.027 2.66-.721 1.273-1.373 1.758-1.373 1.758a11.63 11.63 0 0 1-.79 1.094c-1.444 1.648-4.163 2.216-5.328 2.382 0 0 4.48.499 7.186-1.69 2.705-2.188 3.774-6.315 4.134-8.71.36-2.396.68-6.551.68-6.551a8.068 8.068 0 0 1-.32 1.717z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aN)"
          fillRule="nonzero"
          d="M107.57 24.99a.228.228 0 0 1-.137 0c-.275-.07-1.298-.336-1.597-.476-.35-.168-.836-1.008-.836-1.666 0-.658.511-1.358 1.023-1.582.449-.196 1.41-.252 1.634-.266a.25.25 0 0 1 .1.014l.449.168a.414.414 0 0 1 .187.154c.137.21.424.672.586 1.176a.343.343 0 0 1 .013.196c-.063.42-.35 1.89-1.422 2.282z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aO)"
          fillRule="nonzero"
          d="M108.027 25c.016 0 .024 0 .04-.014.708-.393.897-1.867.93-2.274a.76.76 0 0 0-.009-.196c-.115-.491-.304-.969-.386-1.18a.338.338 0 0 0-.123-.154l-.296-.168c-.017-.014-.025-.014-.041-.014a26.862 26.862 0 0 0-.115 4z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aP)"
          fillRule="nonzero"
          d="M87.774 72.437c-.12-.014-2.3.177-2.658.109-.36-.069-.585-.505-2.154-.546-1.449.164-1.887.928-1.887.928l-.173.177c.186.177.332.341.372.423.146.368-.173.682-.439.819-.265.136-1.395.109-1.395.109h-1.29c-.385 0-.717-.178-.85-.328 0 0-.333.068-.838-.34-.385-.315-1.063-.901-1.396-1.324l-6.287-.055c-.2.273-.505.45-.864.45a1.05 1.05 0 0 1-.691-.272l-.186.054.505.9c-.824.792-1.675.901-1.675.901l-.678-1.214c-.797-.191-2.193-.832-2.193-.832a2.04 2.04 0 0 1-.067 1.241c-.252.641-.571 1.105-.93 1.337 0 0 2.113 1.31 4.958 1.31 0 0 .106.204.492.204.385 0 1.369-.095 2.672 0 1.302.096 3.23.45 4.453.15 0 0 3.163.069 5.024.246 1.861.177 2.433.191 2.632-.245 0 0 3.908-1.31 5.37-1.474 0 0 .386-.15.399-1.35 0-1.215-.106-1.365-.226-1.378z"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aQ)"
          fillRule="nonzero"
          d="M111.095 33.515s-.467.421-1.183.639c-.452.136-1.021.163-1.08-.095-.058-.272.263-.367.263-.367L107.577 31 106 34.412s1.24 1.196 2.818 1.02l.38.38c.189.19.48.245.729.123l2.073-.938-.905-1.482z"
        />
        <circle cx={76} cy={59} r={6} fill="url(#icon-motorcycle-off_svg__aR)" fillRule="nonzero" />
        <circle
          cx={76.5}
          cy={59.5}
          r={2.5}
          fill="url(#icon-motorcycle-off_svg__aS)"
          fillRule="nonzero"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aT)"
          fillRule="nonzero"
          d="M67.63 70h6.764l.606-.575L65 66z"
        />
        <circle
          cx={67.5}
          cy={71.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__aU)"
          fillRule="nonzero"
        />
        <circle
          cx={64.5}
          cy={65.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__aV)"
          fillRule="nonzero"
        />
        <circle cx={85} cy={62} r={3} fill="url(#icon-motorcycle-off_svg__aW)" fillRule="nonzero" />
        <circle
          cx={85.5}
          cy={62.5}
          r={1.5}
          fill="url(#icon-motorcycle-off_svg__aX)"
          fillRule="nonzero"
        />
        <circle
          cx={85.5}
          cy={62.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__aY)"
          fillRule="nonzero"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__aZ)"
          fillRule="nonzero"
          d="M41 46.815l1.02-1.375c.33-.441.952-.567 1.442-.302.556.315.714 1.021.317 1.513L42.721 48c0 .012-.914-.832-1.721-1.185z"
        />
        <circle
          cx={42.5}
          cy={46.5}
          r={1}
          fill="url(#icon-motorcycle-off_svg__ba)"
          fillRule="nonzero"
        />
        <path
          fill="url(#icon-motorcycle-off_svg__bb)"
          fillRule="nonzero"
          d="M63 54.842l-15.664-9.234s-3.16-1.743-4.83-3.433c-1.118-1.131-2.801-4.578-2.801-4.578s-.414-.918.29-1.357c-.29-.519-1.588-1.45-2.181-1.197-.607.252-1.077.838-.649 2.235.4 1.344 3.368 6.2 4.623 6.933C42.617 44.703 61.73 56 61.73 56L63 54.842z"
        />
      </g>
    </g>
  </svg>
);

export default SvgIconMotorcycleOff;
